/* ===========================================
   FEATURED PRODUCTS CUSTOM - JavaScript
   =========================================== */

// Color name to hex mapping for swatches
const fpcColorMap = {
  // Reds & Pinks
  'red': '#FF0000',
  'darkred': '#8B0000',
  'crimson': '#DC143C',
  'pink': '#FFC0CB',
  'hotpink': '#FF69B4',
  'deeppink': '#FF1493',
  'lightpink': '#F4C6D0',
  'light pink': '#F4C6D0',
  'heliconia': '#D63D7E',
  'heliconiapink': '#D63D7E',
  'heliconia pink': '#D63D7E',
  'rose': '#FF007F',
  'coral': '#FF7F50',
  'coralsilk': '#FF8E7F',
  'coral silk': '#FF8E7F',
  'coralreef': '#FF7F50',
  'coral reef': '#FF7F50',
  'coralpink': '#F88379',
  'coral pink': '#F88379',
  'salmon': '#FA8072',
  'lightsalmon': '#FFA07A',
  'light salmon': '#FFA07A',
  'darksalmon': '#E9967A',
  'dark salmon': '#E9967A',
  'azalea': '#F19CBB',
  'fuschia': '#FF00FF',
  'fuchsia': '#FF00FF',
  'magenta': '#FF00FF',
  'burgundy': '#800020',
  'maroon': '#800000',
  'raspberry': '#E30B5C',
  'blush': '#DE5D83',
  'dustyrose': '#DCAE96',
  'dusty rose': '#DCAE96',
  'rosegold': '#B76E79',
  'rose gold': '#B76E79',
  'rouge': '#A94064',
  'scarlet': '#FF2400',
  'cherry': '#DE3163',
  'cherryred': '#C41E3A',
  'cherry red': '#C41E3A',
  'cerryred': '#C41E3A',
  'cerry red': '#C41E3A',
  'strawberry': '#FC5A8D',
  'berry': '#7A4A72',
  'darkberry': '#7A4A72',
  'dark berry': '#7A4A72',

  // Oranges
  'orange': '#FFA500',
  'brightorange': '#FF5F1F',
  'bright orange': '#FF5F1F',
  'darkorange': '#FF8C00',
  'dark orange': '#FF8C00',
  'lightorange': '#FFD580',
  'light orange': '#FFD580',
  'safetyorange': '#FF6700',
  'safety orange': '#FF6700',
  'neonorange': '#FF5F1F',
  'neon orange': '#FF5F1F',
  'tangerine': '#FF9966',
  'peach': '#FFCBA4',
  'peachpink': '#FFDAB9',
  'peach pink': '#FFDAB9',
  'apricot': '#FBCEB1',
  'rust': '#B7410E',
  'rustorange': '#B7410E',
  'rust orange': '#B7410E',
  'burnt orange': '#CC5500',
  'burntorange': '#CC5500',
  'pumpkin': '#FF7518',
  'pumpkinorange': '#FF7518',
  'pumpkin orange': '#FF7518',
  'papaya': '#FFEFD5',
  'mango': '#FF8243',
  'carrot': '#ED9121',
  'carrotorange': '#ED9121',
  'carrot orange': '#ED9121',
  'persimmon': '#EC5800',
  'terracotta': '#E2725B',
  'terra cotta': '#E2725B',
  'copper': '#B87333',

  // Yellows & Golds
  'yellow': '#FFFF00',
  'brightyellow': '#FFFF00',
  'bright yellow': '#FFFF00',
  'lightyellow': '#FFFFE0',
  'light yellow': '#FFFFE0',
  'gold': '#FFD700',
  'golden': '#FFD700',
  'goldenyellow': '#FFDF00',
  'golden yellow': '#FFDF00',
  'lemon': '#FFF44F',
  'lemonyellow': '#FFF44F',
  'lemon yellow': '#FFF44F',
  'mustard': '#FFDB58',
  'mustardyellow': '#FFDB58',
  'mustard yellow': '#FFDB58',
  'cream': '#FFFDD0',
  'creamyellow': '#FFFDD0',
  'ivory': '#FFFFF0',
  'beige': '#F5F5DC',
  'khaki': '#C3B091',
  'sand': '#C2B280',
  'sandy': '#C2B280',
  'sunflower': '#FFDA03',
  'sunflowyellow': '#FFDA03',
  'sunflower yellow': '#FFDA03',
  'canary': '#FFEF00',
  'canaryyellow': '#FFEF00',
  'canary yellow': '#FFEF00',
  'butter': '#FFFF99',
  'butteryellow': '#FFFF99',
  'butter yellow': '#FFFF99',
  'banana': '#FFE135',
  'bananayellow': '#FFE135',
  'banana yellow': '#FFE135',
  'honey': '#EB9605',
  'honeygold': '#EB9605',
  'honey gold': '#EB9605',
  'maize': '#FBEC5D',
  'goldenrod': '#DAA520',
  'amber': '#FFBF00',

  // Greens
  'green': '#008000',
  'lime': '#00FF00',
  'limegreen': '#32CD32',
  'lime green': '#32CD32',
  'forestgreen': '#228B22',
  'forest green': '#228B22',
  'darkgreen': '#006400',
  'dark green': '#006400',
  'olive': '#808000',
  'olivegreen': '#556B2F',
  'olive green': '#556B2F',
  'mint': '#98FF98',
  'mintgreen': '#98FF98',
  'mint green': '#98FF98',
  'mintcream': '#F5FFFA',
  'mint cream': '#F5FFFA',
  'spearmint': '#45B08C',
  'sage': '#9DC183',
  'sagegreen': '#9DC183',
  'sage green': '#9DC183',
  'emerald': '#50C878',
  'emeraldgreen': '#50C878',
  'emerald green': '#50C878',
  'teal': '#008080',
  'tealgreen': '#006D5B',
  'teal green': '#006D5B',
  'seafoam': '#93E9BE',
  'seafoamgreen': '#93E9BE',
  'seafoam green': '#93E9BE',
  'army': '#4B5320',
  'armygreen': '#4B5320',
  'army green': '#4B5320',
  'hunter': '#355E3B',
  'huntergreen': '#355E3B',
  'hunter green': '#355E3B',
  'kelly': '#4CBB17',
  'kellygreen': '#4CBB17',
  'kelly green': '#4CBB17',
  'neon': '#39FF14',
  'neongreen': '#39FF14',
  'neon green': '#39FF14',
  'jade': '#00A86B',
  'jadegreen': '#00A86B',
  'jade green': '#00A86B',
  'pistachio': '#93C572',
  'fern': '#4F7942',
  'ferngreen': '#4F7942',
  'fern green': '#4F7942',
  'moss': '#8A9A5B',
  'mossgreen': '#8A9A5B',
  'moss green': '#8A9A5B',
  'clover': '#009E60',
  'shamrock': '#009E60',
  'spring': '#00FF7F',
  'springgreen': '#00FF7F',
  'spring green': '#00FF7F',

  // Blues
  'blue': '#0000FF',
  'lightblue': '#ADD8E6',
  'light blue': '#ADD8E6',
  'skyblue': '#87CEEB',
  'sky blue': '#87CEEB',
  'babyblue': '#89CFF0',
  'baby blue': '#89CFF0',
  'navy': '#000080',
  'navyblue': '#000080',
  'navy blue': '#000080',
  'royal': '#4169E1',
  'royalblue': '#4169E1',
  'royal blue': '#4169E1',
  'cobalt': '#0047AB',
  'cobaltblue': '#0047AB',
  'cobalt blue': '#0047AB',
  'turquoise': '#40E0D0',
  'turquoiseblue': '#00FFEF',
  'turquoise blue': '#00FFEF',
  'aqua': '#00FFFF',
  'aquablue': '#00FFFF',
  'aqua blue': '#00FFFF',
  'aquamarine': '#7FFFD4',
  'cyan': '#00FFFF',
  'indigo': '#4B0082',
  'indigoblue': '#4B0082',
  'indigo blue': '#4B0082',
  'steel': '#4682B4',
  'steelblue': '#4682B4',
  'steel blue': '#4682B4',
  'powder': '#B0E0E6',
  'powderblue': '#B0E0E6',
  'powder blue': '#B0E0E6',
  'denim': '#1560BD',
  'denimblue': '#1560BD',
  'denim blue': '#1560BD',
  'slate': '#708090',
  'slateblue': '#6A5ACD',
  'slate blue': '#6A5ACD',
  'ocean': '#006994',
  'oceanblue': '#006994',
  'ocean blue': '#006994',
  'carolina': '#99BADD',
  'carolinablue': '#99BADD',
  'carolina blue': '#99BADD',
  'midnight': '#191970',
  'midnightblue': '#191970',
  'midnight blue': '#191970',
  'electric': '#7DF9FF',
  'electricblue': '#7DF9FF',
  'electric blue': '#7DF9FF',
  'ice': '#D6FFFA',
  'iceblue': '#D6FFFA',
  'ice blue': '#D6FFFA',
  'cornflower': '#6495ED',
  'cornflowerblue': '#6495ED',
  'cornflower blue': '#6495ED',
  'sapphire': '#0F52BA',
  'sapphireblue': '#0F52BA',
  'sapphire blue': '#0F52BA',
  'peacock': '#005F69',
  'peacockblue': '#005F69',
  'peacock blue': '#005F69',
  'periwinkle': '#CCCCFF',
  'periwinkleblue': '#CCCCFF',
  'periwinkle blue': '#CCCCFF',

  // Purples & Violets
  'purple': '#800080',
  'darkpurple': '#301934',
  'dark purple': '#301934',
  'lightpurple': '#CBC3E3',
  'light purple': '#CBC3E3',
  'violet': '#EE82EE',
  'darkviolet': '#9400D3',
  'dark violet': '#9400D3',
  'lavender': '#E6E6FA',
  'lavenderpurple': '#967BB6',
  'lavender purple': '#967BB6',
  'plum': '#DDA0DD',
  'plumpurple': '#8E4585',
  'plum purple': '#8E4585',
  'orchid': '#DA70D6',
  'orchidpurple': '#DA70D6',
  'orchid purple': '#DA70D6',
  'grape': '#6F2DA8',
  'grapepurple': '#6F2DA8',
  'grape purple': '#6F2DA8',
  'lilac': '#C8A2C8',
  'lilacpurple': '#C8A2C8',
  'lilac purple': '#C8A2C8',
  'mauve': '#E0B0FF',
  'eggplant': '#614051',
  'wine': '#722F37',
  'winered': '#722F37',
  'wine red': '#722F37',
  'amethyst': '#9966CC',
  'wisteria': '#C9A0DC',
  'iris': '#5D3FD3',
  'irispurple': '#5D3FD3',
  'iris purple': '#5D3FD3',
  'royalpurple': '#7851A9',
  'royal purple': '#7851A9',
  'mulberry': '#C54B8C',
  'heliotrope': '#DF73FF',
  'ultraviolet': '#645394',
  'ultra violet': '#645394',

  // Browns
  'brown': '#A52A2A',
  'chocolate': '#D2691E',
  'coffee': '#6F4E37',
  'tan': '#D2B48C',
  'taupe': '#483C32',
  'camel': '#C19A6B',
  'mocha': '#967969',
  'espresso': '#3C2415',
  'cinnamon': '#D2691E',
  'chestnut': '#954535',
  'yam': '#C07848',
  'yamorange': '#C07848',
  'yam orange': '#C07848',

  // Neutrals
  'black': '#000000',
  'jetblack': '#0A0A0A',
  'jet black': '#0A0A0A',
  'white': '#FFFFFF',
  'purewhite': '#FFFFFF',
  'pure white': '#FFFFFF',
  'snowwhite': '#FFFAFA',
  'snow white': '#FFFAFA',
  'gray': '#808080',
  'grey': '#808080',
  'silver': '#C0C0C0',
  'charcoal': '#36454F',
  'charcoalgray': '#36454F',
  'charcoal gray': '#36454F',
  'charcoalgrey': '#36454F',
  'charcoal grey': '#36454F',
  'ash': '#B2BEB5',
  'ashgray': '#B2BEB5',
  'ash gray': '#B2BEB5',
  'ashgrey': '#B2BEB5',
  'ash grey': '#B2BEB5',
  'lightgray': '#D3D3D3',
  'lightgrey': '#D3D3D3',
  'light gray': '#D3D3D3',
  'light grey': '#D3D3D3',
  'darkgray': '#A9A9A9',
  'darkgrey': '#A9A9A9',
  'dark gray': '#A9A9A9',
  'dark grey': '#A9A9A9',
  'offwhite': '#FAF9F6',
  'off-white': '#FAF9F6',
  'off white': '#FAF9F6',
  'natural': '#FAF0E6',
  'oatmeal': '#D4C4A8',
  'heather': '#9E9E9E',
  'heathergray': '#9E9E9E',
  'heathergrey': '#9E9E9E',
  'heather gray': '#9E9E9E',
  'heather grey': '#9E9E9E',
  'stone': '#918E85',
  'stonegray': '#918E85',
  'stone gray': '#918E85',
  'graphite': '#383838',
  'pewter': '#8F8F8F',
  'platinum': '#E5E4E2',
  'smoke': '#738276',
  'smokegray': '#738276',
  'smoke gray': '#738276',
  'iron': '#48494B',
  'irongray': '#48494B',
  'iron gray': '#48494B',
  'titanium': '#878681',
  'gunmetal': '#2C3539',
  'anthracite': '#293133',

  // Metallics
  'metallic': 'linear-gradient(135deg, #C0C0C0, #E8E8E8, #C0C0C0)',
  'holographic': 'linear-gradient(135deg, #ff0000, #ff7f00, #ffff00, #00ff00, #0000ff, #4b0082, #9400d3)',
  'iridescent': 'linear-gradient(135deg, #a8edea, #fed6e3, #a8edea)',
};

/**
 * Get color value from color name
 */
function fpcGetColorValue(colorName) {
  if (!colorName) return '#CCCCCC';
  
  // Normalize the color name
  const normalized = colorName.toLowerCase().replace(/[\s-_]/g, '');
  
  // Check if it's already a hex color
  if (colorName.startsWith('#')) return colorName;
  
  // Check our color map
  if (fpcColorMap[normalized]) return fpcColorMap[normalized];
  
  // Check with spaces preserved (lowercase)
  const withSpaces = colorName.toLowerCase();
  if (fpcColorMap[withSpaces]) return fpcColorMap[withSpaces];
  
  // Try standard CSS color (browser will validate)
  return colorName.toLowerCase();
}

/**
 * Format money according to Shopify format
 */
function fpcFormatMoney(cents, moneyFormat) {
  if (typeof cents === 'string') {
    cents = cents.replace('.', '');
  }
  const value = (Number(cents) / 100).toFixed(2);
  let formattedValue = moneyFormat.replace(/\{\{\s*amount\s*\}\}/g, value);
  formattedValue = formattedValue.replace(/\{\{\s*amount_no_decimals\s*\}\}/g, Math.round(value));
  formattedValue = formattedValue.replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, value.replace('.', ','));
  return formattedValue;
}

/**
 * Add item to cart
 */
function fpcAddToCart(variantId, quantity, button) {
  const originalText = button.innerHTML;
  button.disabled = true;
  button.innerHTML = 'Adding...';

  const cartDrawer = document.querySelector('cart-drawer');
  let sectionsToRender = [];
  if (cartDrawer) {
    sectionsToRender = cartDrawer.getSectionsToRender().map(s => s.id);
  }

  fetch(window.Shopify.routes.root + 'cart/add.js', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Requested-With': 'XMLHttpRequest'
    },
    body: JSON.stringify({
      items: [{
        id: variantId,
        quantity: quantity
      }],
      sections: sectionsToRender.join(','),
      sections_url: window.location.pathname
    })
  })
  .then(response => response.json())
  .then(data => {
    button.innerHTML = 'Added!';
    setTimeout(() => {
      button.innerHTML = originalText;
      button.disabled = false;
    }, 1500);

    if (cartDrawer && data.sections) {
      cartDrawer.classList.remove('is-empty');
      cartDrawer.renderContents(data);
    } else {
      // Dispatch cart update event
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      
      // Update cart count
      fetch(window.Shopify.routes.root + 'cart.js')
        .then(res => res.json())
        .then(cart => {
          const cartCounts = document.querySelectorAll('.cart-count-bubble span, .ralphs-cart-badge');
          cartCounts.forEach(el => {
            el.textContent = cart.item_count;
            el.closest('.cart-count-bubble, .ralphs-cart-badge')?.classList.remove('hidden');
          });
        });
    }
  })
  .catch(error => {
    console.error('Error adding to cart:', error);
    button.innerHTML = 'Error';
    setTimeout(() => {
      button.innerHTML = originalText;
      button.disabled = false;
    }, 1500);
  });
}

/**
 * Find a swatch by option index and value without building a CSS selector
 * (values like 36" × 72" contain quotes that break querySelector)
 */
function fpcFindSwatch(card, index, value) {
  const swatches = card.querySelectorAll('[data-option-index="' + index + '"]');
  for (let i = 0; i < swatches.length; i++) {
    if (swatches[i].dataset.optionValue === value) {
      return swatches[i];
    }
  }
  return null;
}

/**
 * Update selected swatches UI
 */
function fpcUpdateSelectedSwatches(card, selectedOptions) {
  selectedOptions.forEach((value, index) => {
    const swatch = fpcFindSwatch(card, index, value);
    if (swatch) {
      const optionGroup = swatch.closest('.fpc-card__option-group');
      optionGroup.querySelectorAll('[data-option-value]').forEach(s => s.classList.remove('selected'));
      swatch.classList.add('selected');
    }
  });
}

/**
 * Update available swatches based on current selection
 */
function fpcUpdateAvailableSwatches(card, variants, selectedOptions) {
  const optionGroups = card.querySelectorAll('.fpc-card__option-group');
  
  optionGroups.forEach((group, groupIndex) => {
    const swatches = group.querySelectorAll('[data-option-value]');
    
    swatches.forEach(swatch => {
      const value = swatch.dataset.optionValue;
      
      // Check if any variant with this option value is available
      const isAvailable = variants.some(v => {
        if (!v.available) return false;
        if (v.options[groupIndex] !== value) return false;
        
        // Check if other selected options match
        return selectedOptions.every((selectedVal, idx) => {
          if (idx === groupIndex) return true;
          return v.options[idx] === selectedVal;
        });
      });

      if (isAvailable) {
        swatch.classList.remove('unavailable');
        swatch.disabled = false;
      } else {
        swatch.classList.add('unavailable');
        swatch.disabled = true;
      }
    });
  });
}

/**
 * Initialize Featured Products Custom section
 */
function initFeaturedProductsCustom(sectionId, moneyFormat) {
  const section = document.querySelector('.section-fpc-' + sectionId);
  if (!section) return;

  // Apply color mapping to all color swatches
  section.querySelectorAll('.fpc-swatch--color:not([data-fpc-initialized])').forEach(swatch => {
    swatch.dataset.fpcInitialized = 'true';
    const colorName = swatch.dataset.optionValue;
    const colorValue = fpcGetColorValue(colorName);
    
    if (colorValue.includes('gradient')) {
      swatch.style.background = colorValue;
    } else {
      swatch.style.backgroundColor = colorValue;
    }
  });

  const cards = section.querySelectorAll('.fpc-card[data-product-id]:not([data-fpc-initialized])');

  cards.forEach(card => {
    card.dataset.fpcInitialized = 'true';
    const productId = card.dataset.productId;
    const variantsData = card.querySelector('[data-product-variants="' + productId + '"]');
    const mediaData = card.querySelector('[data-product-media="' + productId + '"]');
    
    if (!variantsData) return;

    const variants = JSON.parse(variantsData.textContent);
    const media = mediaData ? JSON.parse(mediaData.textContent) : {};
    const swatches = card.querySelectorAll('[data-option-value]');
    const addToCartBtn = card.querySelector('[data-add-to-cart]');
    const productImage = card.querySelector('[data-product-image]');
    const priceElement = card.querySelector('[data-price-value]');
    const comparePriceElement = card.querySelector('[data-compare-price]');

    // Track selected options
    let selectedOptions = [];
    
    // Initialize with first available variant
    const firstAvailable = variants.find(v => v.available) || variants[0];
    if (firstAvailable) {
      selectedOptions = [...firstAvailable.options];
      fpcUpdateSelectedSwatches(card, selectedOptions);
      
      if (addToCartBtn) {
        addToCartBtn.dataset.variantId = firstAvailable.id;
      }
      
      // Update image to match first available variant
      if (productImage && media[firstAvailable.id]) {
        productImage.src = media[firstAvailable.id];
        productImage.removeAttribute('srcset');
      }
      
      // Update price to match first available variant
      if (priceElement) {
        priceElement.textContent = fpcFormatMoney(firstAvailable.price, moneyFormat);
      }
      
      // Update compare price
      if (comparePriceElement) {
        if (firstAvailable.compare_at_price && firstAvailable.compare_at_price > firstAvailable.price) {
          comparePriceElement.textContent = fpcFormatMoney(firstAvailable.compare_at_price, moneyFormat);
          comparePriceElement.style.display = '';
        } else {
          comparePriceElement.style.display = 'none';
        }
      }
    }

    // Swatch click handler
    swatches.forEach(swatch => {
      swatch.addEventListener('click', function() {
        if (this.classList.contains('unavailable') || this.disabled) return;

        const optionIndex = parseInt(this.dataset.optionIndex);
        const optionValue = this.dataset.optionValue;

        // Update selected option
        selectedOptions[optionIndex] = optionValue;

        // Update swatch UI
        const optionGroup = this.closest('.fpc-card__option-group');
        optionGroup.querySelectorAll('[data-option-value]').forEach(s => s.classList.remove('selected'));
        this.classList.add('selected');

        // Find matching variant
        const matchingVariant = variants.find(v => {
          return v.options.every((opt, idx) => opt === selectedOptions[idx]);
        });

        if (matchingVariant) {
          // Update variant ID on button
          if (addToCartBtn) {
            addToCartBtn.dataset.variantId = matchingVariant.id;
            addToCartBtn.disabled = !matchingVariant.available;
          }

          // Update image
          if (productImage && media[matchingVariant.id]) {
            productImage.src = media[matchingVariant.id];
            productImage.removeAttribute('srcset');
          }

          // Update price
          if (priceElement) {
            priceElement.textContent = fpcFormatMoney(matchingVariant.price, moneyFormat);
          }

          // Update compare price
          if (comparePriceElement) {
            if (matchingVariant.compare_at_price && matchingVariant.compare_at_price > matchingVariant.price) {
              comparePriceElement.textContent = fpcFormatMoney(matchingVariant.compare_at_price, moneyFormat);
              comparePriceElement.style.display = '';
            } else {
              comparePriceElement.style.display = 'none';
            }
          }

          // Update available swatches based on selection
          fpcUpdateAvailableSwatches(card, variants, selectedOptions);
        }
      });
    });

    // Add to cart handler
    if (addToCartBtn) {
      addToCartBtn.addEventListener('click', function() {
        const variantId = this.dataset.variantId;
        
        if (!variantId) {
          // Highlight options that need selection
          card.querySelectorAll('.fpc-card__option-group').forEach(group => {
            if (!group.querySelector('.selected')) {
              group.classList.add('highlight');
              setTimeout(() => group.classList.remove('highlight'), 1000);
            }
          });
          return;
        }

        // Add to cart
        fpcAddToCart(variantId, 1, this);
      });
    }
  });
}

// Export for use
window.initFeaturedProductsCustom = initFeaturedProductsCustom;
